import * as React from 'react';

import { UitkExpandoPeek } from 'uitk-react-expando';
import { AnalyticsConfig } from 'uitk-react-utils';

import { SortFilterStore } from 'stores';
import { trackAnalytics } from 'utility';
import { FILTER_TYPE_TO_ID_PREFIX, FILTER_HEIGHT_IN_PX, FILTER_FADE_THRESHOLD_FACTOR } from 'utility/filter-constants';
import { useStores } from 'utility/hooks';

import { ListFilter, ListDisplayFilterGroupLegend } from '.';

import { FlightsListDisplayFilterOptionType, FlightsFilterOptionType } from 'types/search/sort-filter';
import { FlightsListDisplayFilterItemType, FlightsFilterItemType } from 'types/shared';

interface ListDisplayFilterGroupProps {
  keySuffix: string;
  filterOption: FlightsFilterOptionType;
  sortFilterStore?: SortFilterStore;
  updateFilter: (keySuffix: string) => void;
}

const computeFilterExpandHeight = (itemsDefaultDisplayCount: number) =>
  FILTER_HEIGHT_IN_PX * (FILTER_FADE_THRESHOLD_FACTOR + itemsDefaultDisplayCount);

const renderListFilters = (
  items: FlightsFilterItemType[],
  type: string,
  keySuffix: string,
  updateFilter: (keySuffix: string) => void
) =>
  items.map((filterItem: FlightsListDisplayFilterItemType, key: number) => {
    const idPrefix = FILTER_TYPE_TO_ID_PREFIX[type];

    return (
      <ListFilter
        key={`${idPrefix}-${key}`}
        updateFilter={updateFilter}
        filterItem={filterItem}
        idPrefix={idPrefix}
        keySuffix={keySuffix}
      />
    );
  });

export const ListDisplayFilterGroup = ({ filterOption, keySuffix, updateFilter }: ListDisplayFilterGroupProps) => {
  const {
    itemsDefaultDisplayCount,
    label,
    priceFromLabel,
    showMoreToggle,
    items,
    type
  } = filterOption as FlightsListDisplayFilterOptionType;
  const labelLegend = `${label}-legend`;

  const { analytics } = useStores();
  const analyticsCallback: AnalyticsConfig = {
    id: 'FilterOption.Toggle.Analytics',
    callback: id => {
      id.indexOf('ShowMore') > -1
        ? trackAnalytics(showMoreToggle.expandActionable.analytics, analytics)
        : trackAnalytics(showMoreToggle.collapseActionable.analytics, analytics);
    }
  };

  return (
    <fieldset className="all-b-margin-six">
      <ListDisplayFilterGroupLegend labelLegend={label} labelLegendId={labelLegend} secondaryLabel={priceFromLabel} />
      <div className="all-t-margin-two">
        {items.length > itemsDefaultDisplayCount && showMoreToggle ? (
          <UitkExpandoPeek
            threshold={computeFilterExpandHeight(itemsDefaultDisplayCount)}
            collapseHeight={computeFilterExpandHeight(itemsDefaultDisplayCount)}
            collapseLabel={showMoreToggle.collapseActionable.action}
            expandLabel={showMoreToggle.expandActionable.action}
            analytics={analyticsCallback}
          >
            {renderListFilters(items, type, keySuffix, updateFilter)}
          </UitkExpandoPeek>
        ) : (
          renderListFilters(items, type, keySuffix, updateFilter)
        )}
      </div>
    </fieldset>
  );
};
